import React from 'react';
import PropTypes from 'prop-types';
import MentionMe from '../MentionMe';
import RichText from '../Prismic/RichText';
import './ReferAFriend.scss';

const ReferAFriend = props => {
  const { title, offerType, situation, selector, country } = props;
  return (
    <section className="refer-a-friend">
      <div className="container-guttered refer-a-friend-wrapper">
        <RichText
          className="refer-a-friend-title"
          fields={title}
        />
        <MentionMe
          type={offerType}
          situation={situation}
          id={selector}
          implementation="embed"
          country={country}
          showLoader
        />
      </div>
    </section>
  );
};

ReferAFriend.propTypes = {
  country: PropTypes.object,
  title: PropTypes.array,
  offerType: PropTypes.string.isRequired,
  situation: PropTypes.string.isRequired,
  selector: PropTypes.string.isRequired
};

export default ReferAFriend;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ReferAFriend/ReferAFriend.js